import { render, staticRenderFns } from "./CsvUpload.vue?vue&type=template&id=98b92b68&scoped=true&"
import script from "./CsvUpload.vue?vue&type=script&lang=js&"
export * from "./CsvUpload.vue?vue&type=script&lang=js&"
import style0 from "./CsvUpload.vue?vue&type=style&index=0&id=98b92b68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b92b68",
  null
  
)

export default component.exports